import {
  afterRenderEffect,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { TowersService } from '../towers.service';
import { TowersItemComponent } from '../towers-item/towers-item.component';
import { ModalService } from '@features/modals/services/modal.service';

@Component({
  selector: 'app-towers-area',
  templateUrl: './towers-area.component.html',
  styleUrls: ['./towers-area.component.scss'],
  standalone: true,
  host: {
    class: 'box-black-third rounded-6',
  },
  imports: [TowersItemComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TowersAreaComponent {
  @ViewChild('progressLeft', { read: ElementRef })
  progressLeft!: ElementRef<HTMLDivElement>;
  @ViewChild('progressRight', { read: ElementRef })
  progressRight!: ElementRef<HTMLDivElement>;

  constructor(
    public towersService: TowersService,
    private modalService: ModalService
  ) {
    afterRenderEffect(() => {
      if (this.towersService.currentGame()?.status === 'finished') {
        const towersResultsModal = this.modalService.openModal(
          'TowersResultsModalComponent',
          {
            results: {
              multiplier: towersService.currentMultiplier(),
              balance: towersService.currentGame()?.balancetype,
              value:
                towersService.currentMultiplier() *
                (towersService.currentGame()?.value || 0),
              won: towersService.currentGame()?.won,
            },
          }
        );
      }
    });

    afterRenderEffect(async () => {
      if (this.towersService.repeat()) {
        await this.towersService.startTowers({
          tiles:
            this.towersService.currentGame()?.tiles ??
            this.towersService.mode().tiles,
          death_tiles:
            this.towersService.currentGame()?.death_tiles ??
            this.towersService.mode().death_tiles,
          amount:
            this.towersService.currentGame()?.value ??
            this.towersService.amount(),
        });
      }
    });
  }
}
